import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PasswordValidator } from '../ndm/management/manage_user/add_user/password.validator';
import { UserInfo } from '../ndm/models/user.model';
import { AuthService } from '../services/authenticate.service';
import { NotificationService } from '../services/notification.service';
import { UserService } from '../services/user.service';
import { LoaderService } from '../shared/loader/loader.service';
import * as constants from '../config/app.constants';

@Component({
    selector: 'app-change_password',
    templateUrl: 'change_password.component.html',
    styleUrls: ['change_password.component.css'],
    standalone: false
})
export class Change_passwordComponent {
  form: FormGroup = new FormGroup({});
  showForgotPassword: boolean = false;
  token: string = '';
  passwordChanged: Boolean = false;
  userInfo: UserInfo = new UserInfo();
  constructor(private readonly authService: AuthService,
    private readonly router: Router
    , private readonly toast: NotificationService
    , private readonly loader: LoaderService
    , private activeRoute: ActivatedRoute
    , private userService: UserService) {
    this.initiateFormGroup();
    this.getUserDetails();
  }

  initiateFormGroup() {
    this.form = new FormGroup({
      'oldPassword': new FormControl("", [Validators.required]),
      'newPassword': new FormControl("", [Validators.required, PasswordValidator.strong]),
      'confirmPassword': new FormControl("", [Validators.required]),
    })
  }

  getUserDetails() {
    this.authService.getLoggedInUserInfo().subscribe(res => {
      this.userInfo = res;
      if (this.userInfo.email == null || this.userInfo.email == "") {
        this.form.addControl("email", new FormControl(this.userInfo.email, [Validators.required, Validators.pattern(constants.VALIDATE_EMAIL_ADDRESS)]));
      }
    })
  }

  comparePassword() {
    let data = this.form.value;
    if (data.password !== data.confirmpassword) {
      this.toast.showError("New password and compare password should be same");
      return false;
    }
    return true;
  }

  submitPage() {

    this.passwordChanged = false;
    if (this.validatePage() && this.comparePassword()) {
      this.loader.start();
      let request: any = {};
      request.oldPassword = this.form.get("oldPassword")?.value;
      request.newPassword = this.form.get("newPassword")?.value;
      if (this.userInfo.email == null || this.userInfo.email == '') {
        alert('Please reach out application admin by sending email from your preferred email account to general@anmw.co.uk to add your email and activate your account .Thank you');
      }
      else {
        this.authService.updatePassword(request).subscribe(res => {
          this.loader.stop();
          sessionStorage.clear();
          this.toast.showSuccess("Password changed successfully, Please login again");
          this.router.navigate(['./login']);
        },
          (error: any) => {
            this.loader.stop();
            this.toast.showException(error.error);
          });
      }
    }
  }

  reset() {
    this.form.reset();
  }

  validatePage(): boolean {
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.markAsDirty();
        this.form.get(key)?.markAsTouched();
      }
    })
    return this.form.valid;
  }
}